import CryptoJS from "crypto-js";
const key = "TheBestSecretKey"


const secretPass = CryptoJS.enc.Utf8.parse(`${key}` || "");

export const encryptData = (jsonObject) => {
  try {
    const plainText = JSON.stringify(jsonObject);

    const encryptResult = CryptoJS.AES.encrypt(
      plainText.toString(),
      secretPass,
      {
        iv: secretPass,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );

    return encryptResult.toString();
  } catch (error) {
    throw error;
  }
};
